;(function () {
  'use strict';

  let angular = window.angular;

  TelegramChatFormController.$inject = [
    '$scope',
    '$timeout',
    'Customer',
    'AppUtils',
  ];

  angular
    .module('app')
    .component('connectionTelegramChatForm', {
      template:'<form class="validate" name="ctrl.telegramChatForm" novalidate ng-class="{transparent: ctrl.saving}"><div class="modal-header"><span>{{:: ctrl.telegramChat.id? \'form.actions.update\': \'form.actions.create\' | translate}}</span> <span translate>entities.telegramchat.modelName</span></div><div class="modal-body"><div><div class="form-group" show-errors><label for="createTelegramChatName"><span translate>entities._all.name</span> <span class="text-danger">*</span></label> <input id="createTelegramChatName" ng-model="ctrl.telegramChat.name" class="form-control" translate-attr="{placeholder:\'entities._all.name\'}" name="telegramChatName" required><div class="help-block" ng-messages="ctrl.telegramChatForm.telegramChatName.$error"><div ng-messages-include="messages.html"></div></div></div><div class="form-group" show-errors><label for="createTelegramChatChatId"><span>Telegram Chat Id</span> <span class="text-danger">*</span></label> <input id="createTelegramChatChatId" ng-model="ctrl.telegramChat.chatId" class="form-control" placeholder="Telegram Chat Id" name="telegramChatChatId" required><div class="help-block" ng-messages="ctrl.telegramChatForm.telegramChatChatId.$error"><div ng-messages-include="messages.html"></div></div></div><div class="form-group no-margin"><label class="control-label" for="descriptionInput" translate>entities._all.description</label> <textarea id="descriptionInput" name="descriptionInput" maxlength="10000" simplemde="ctrl.mdeOptions" ng-model="ctrl.telegramChat.description" class="form-control input-sm"></textarea></div></div></div><div ng-if="ctrl.createTelegramChatError" class="alert alert-warning text-center marginB0">{{ctrl.createTelegramChatError}}</div><div class="modal-footer"><button class="btn btn-default pull-left" ng-click="ctrl.modalInstance.dismiss()" ng-show="!ctrl.saving" translate>buttons.cancel</button> <button ng-disabled="ctrl.saving" class="btn btn-primary" ng-click="ctrl.save()" translate>buttons.save</button></div></form><spinner css-class="\'small\'" show-logo="true" show="ctrl.saving"></spinner>',
      controller: TelegramChatFormController,
      controllerAs: 'ctrl',
      bindings: {
        modalInstance: '<',
        resolve: '<'
      }
    });

  function TelegramChatFormController ($scope, $timeout, Customer, utils) {
    let vm = this;

    vm.$onInit = function onInit () {
      vm.telegramChat = vm.resolve.telegramChat ? angular.copy(vm.resolve.telegramChat) : {};
      vm.operation = vm.telegramChat.id ? 'Update' : 'Create';
      vm.customer = vm.resolve.customer;

      vm.mdeOptions = {
        spellChecker: false,
        toolbar: [
          'bold', 'italic', 'heading', '|',
          'unordered-list', 'ordered-list', '|',
          'quote', 'link', 'table', 'code', '|',
          'preview'
        ]
      };

      vm.save = createTelegramChat;
    };

    function createTelegramChat () {
      $scope.$broadcast('show-errors-check-validity');
      if (!vm.telegramChat || !vm.telegramChatForm.$valid) {
        return;
      }

      let telegramChat = {
        name: vm.telegramChat.name,
        chatId: vm.telegramChat.chatId,
        description: vm.telegramChat.description
      };

      let promise;
      if (vm.telegramChat.id) {
        promise = Customer.telegramChats
          .updateById({
            id: vm.customer.id,
            fk: vm.telegramChat.id
          }, telegramChat)
          .$promise;
      } else {
        promise = Customer.telegramChats
          .create({
            id: vm.customer.id
          }, telegramChat)
          .$promise;
      }

      vm.saving = true;
      promise
        .then(function (result) {
          vm.modalInstance.close({
            operation: vm.telegramChat.id ? 'update' : 'create',
            telegramChat: result,
            node: {
              id: result.id,
              text: result.name,
              parent: '#'
            }
          });
        })
        .catch(function (err) {
          vm.saving = false;
          vm.createTelegramChatError = utils.getHTTPError(err);
        });
    }
  }
})();
